export default function () {
  return useState('host', () => (process.server ? useRequestHeaders().host : document.location.host))
}
